import { AfterViewInit, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { IconService } from "bookraw/shared/services/icon.service";

@Component({
  selector: 'app-ico54',
  templateUrl: './ico54.component.html',
  styleUrls: ['./ico54.component.scss']
})
export class Ico54Component implements AfterViewInit, OnChanges {
  @Input() name: string;
  @Input() isFullUrl: boolean = false;
  @ViewChild('iconContainer') iconContainer: ElementRef;

  constructor(private iconService: IconService) { }

  ngAfterViewInit(): void {
    this.loadSvgIcon();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.name) {
      this.loadSvgIcon();
    }
  }

  loadSvgIcon() {
    // ha nincs megadva ikon akkor nem próbáljuk meg betölteni
    if (!this.name) {
      return;
    }

    this.iconService.getIcon(this.name, this.isFullUrl).subscribe(res => {
      if (this.iconContainer) {
        this.iconContainer.nativeElement.innerHTML = res;
      }
    });
  }
}
